// -- React Libraries
import React from 'react';

// -- Styles
import StyleWrapper from "./Wrapper";

export default class GridContent extends React.Component {
    render() {
        return (
            <StyleWrapper className={`grid-content ${ this.props.className ? this.props.className : "" }`}>
                {
                    this.props.title && this.props.title.length > 0 && (
                        <div className="content-title">{this.props.title}</div>
                    )
                }
                <div className="content-explain">{this.props.children}</div>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/GridContent/index.js